module.exports = "/images/handypay.png?e3bddc73d272afe934d92f5d15282d5c";